import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { SpouseAdditionalInformationDescription } from '../../../../components/FormDescriptions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--spouse-addtl-info-title'];
const INPUT_LABELS = {
  cohabited: strWithYear(
    content['household-info--spouse-addtl-info-cohabited-label'],
  ),
  address: content['household-info--spouse-addtl-info-address-label'],
};

const { cohabitedLastYear, sameAddress } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, SpouseAdditionalInformationDescription),
    cohabitedLastYear: yesNoUI(INPUT_LABELS.cohabited),
    sameAddress: yesNoUI(INPUT_LABELS.address),
  },
  schema: {
    type: 'object',
    required: ['sameAddress'],
    properties: { cohabitedLastYear, sameAddress },
  },
};
